import { graphql } from '~/gql'

export default graphql(`
  query GetSalesforceUserId {
    Salesforce {
      salesforceUserId
    }
  }
`)
